<h4 class="tt-chapters-tree_title">{{ 'TableOfContents' | transloco }}</h4>
<div class="tt-chapters-tree_tree-container">
  <tt-tree
    class="tt-chapters-tree_tree"
    [activeNodeId]="activeChapter()?.id"
    [beforeDeleteCallback]="confirmDeletion"
    [dataSource]="chapterTreeItems()"
    [expandAll]="true"
    [maxDepth]="4"
    [nodeTemplate]="hasResourceTags() ? resourceTagsTemplate : undefined"
    [readonly]="readonly"
    [selected]="selectedChapters()"
    [showAddButton]="true"
    [showAllButton]="false"
    [showDot]="false"
    [showExpandToggle]="true"
    (nodeAdded)="onAddChapter($event)"
    (nodeDeleted)="onDeleteChapter($event)"
    (nodeDropped)="onNodeDropped($event)"
    (nodeEdited)="onEditChapter($event)"
    (nodesSelected)="scrollToChapter($event[0])" />
</div>

<ng-template #resourceTagsTemplate let-node>
  @if (node.no) {
    <span class="tt-tree_node-expand-icon-placeholder"></span>
    <span class="tt-tree_node-number">{{ node.no }}.&nbsp;</span>
  }
  <span class="tt-tree_node-title-text">{{ node.title }}</span>
  @if (node.item.resourceTags?.length) {
    <div class="tt-tree_node-title-tags">
      @for (tag of node.item.resourceTags; track tag.id) {
        <tt-dot class="tt-tree_node-title-tags-item" [customColor]="tag.color" />
      }
    </div>
  }
</ng-template>
